import { render, staticRenderFns } from "./hqglBenefitsFee.vue?vue&type=template&id=3891c29f&scoped=true&"
import script from "./hqglBenefitsFee.vue?vue&type=script&lang=js&"
export * from "./hqglBenefitsFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3891c29f",
  null
  
)

export default component.exports